import React from "react";

import Header from "@/src/layout/headers/header";
import HeroArea from "./hero-area";
import TestimonialArea from "./testimonials-area";
import Footer from "@/src/layout/footers/footer";

const CaseStudies = () => {
    return (
        <>
            <Header />
            <main>
                <HeroArea />
                {/* <PortfolioArea /> */}
                <TestimonialArea />
            </main>
            <Footer />
        </>
    );
};

export default CaseStudies;
